import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';

import { ASetHistories, THistories, TRemote } from '../actions';

const fetchHistoriesListeners = [
  THistories.FETCH_HISTORIES,
  TRemote.SET_REMOTE,
  // TPlayer.SET_PLAYER_STATUS
];

let fetchHistoriesEpicTimeout = 0;

export const fetchHistoriesEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => fetchHistoriesListeners.includes(type)),
    filter(() => new Date().getTime() - fetchHistoriesEpicTimeout > 2000),
    tap( () => fetchHistoriesEpicTimeout = new Date().getTime()),
    mergeMap(() => restApi.get('/library/histories?ngsw-bypass=true').pipe(
      /**
       * There is a common handler for all errors.
      * However, we need to return an empty array in case of an error
      * to prevent the error from being propagated to the upper level.
      * If it is not handled here, this interrupts the flow if the API returns a 404.
       */
      catchError(() => of([])),
    )),
    map(ASetHistories)
  );
